/* !!! This file is auto-generated. Please edit the source files instead */
(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
  var __esm = (fn, res, err) => function __init() {
    if (err) throw err[0];
    try {
      return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
    } catch (e) {
      throw err = [e], e;
    }
  };
  var __commonJS = (cb, mod) => function __require() {
    try {
      return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    } catch (e) {
      throw mod = 0, e;
    }
  };
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/js/utils/product-utils.js
  function getOptionNames(product) {
    return (product.options || []).map((opt) => typeof opt === "string" ? opt : opt.name);
  }
  function getOptionValues(product, index) {
    const values = [];
    product.variants.forEach((variant) => {
      const value = variant.options[index];
      if (value != null && !values.includes(value)) values.push(value);
    });
    return values;
  }
  function isValueAvailable(product, index, value, selected) {
    return product.variants.some(
      (variant) => variant.available && variant.options[index] === value && selected.every((sel, i) => i === index || !sel || variant.options[i] === sel)
    );
  }
  function findVariant(product, selected) {
    if (selected.some((value) => !value)) return null;
    return product.variants.find((variant) => selected.every((value, i) => variant.options[i] === value)) || null;
  }
  function addToCart(variantId) {
    return __async(this, null, function* () {
      const body = new FormData();
      body.append("id", variantId);
      body.append("quantity", 1);
      const response = yield fetch(theme.routes.cartAdd, {
        method: "POST",
        headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
        body
      });
      const data = yield response.json();
      if (!response.ok) {
        throw new Error(data.description || data.message || "Add to cart failed");
      }
      document.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
      document.dispatchEvent(
        new CustomEvent("on:cart:add", {
          bubbles: true,
          detail: { variantId: data.variant_id }
        })
      );
      return data;
    });
  }
  var init_product_utils = __esm({
    "src/js/utils/product-utils.js"() {
      __name(getOptionNames, "getOptionNames");
      __name(getOptionValues, "getOptionValues");
      __name(isValueAvailable, "isValueAvailable");
      __name(findVariant, "findVariant");
      __name(addToCart, "addToCart");
    }
  });

  // src/js/cart-upsell.js
  var require_cart_upsell = __commonJS({
    "src/js/cart-upsell.js"(exports) {
      init_product_utils();
      if (!customElements.get("cart-upsell-picker")) {
        const _CartUpsellPicker = class _CartUpsellPicker extends HTMLElement {
          connectedCallback() {
            this.vendorEl = this.querySelector("[data-upsell-vendor]");
            this.titleEl = this.querySelector("[data-upsell-title]");
            this.optionsEl = this.querySelector("[data-upsell-options]");
            this.errorEl = this.querySelector("[data-upsell-error]");
            this.submitBtn = this.querySelector("[data-upsell-submit]");
            this.sizeGuideTemplate = this.querySelector("[data-upsell-size-guide]");
            this.sizeGuideVariants = this.sizeGuideTemplate ? (this.sizeGuideTemplate.dataset.upsellSizeGuideVariant || "").split(",").map((name) => name.trim().toLowerCase()).filter(Boolean) : [];
            this.addEventListener("click", (evt) => {
              if (evt.target.closest("[data-upsell-close]")) {
                this.close();
              } else if (evt.target.closest("[data-upsell-value]")) {
                this.selectValue(evt.target.closest("[data-upsell-value]"));
              }
            });
            this.submitBtn.addEventListener("click", this.handleSubmit.bind(this));
            this.boundHandleKeydown = this.handleKeydown.bind(this);
          }
          handleKeydown(evt) {
            if (evt.key === "Escape") this.close();
          }
          /**
           * Opens the picker for a product.
           * @param {object} product - Product JSON.
           */
          open(product) {
            this.product = product;
            this.selected = getOptionNames(product).map(() => null);
            this.vendorEl.textContent = product.vendor || "";
            this.vendorEl.hidden = !product.vendor;
            this.titleEl.textContent = product.title;
            this.renderOptions();
            this.setError("");
            this.hidden = false;
            document.addEventListener("keydown", this.boundHandleKeydown);
            requestAnimationFrame(() => this.classList.add("is-open"));
          }
          close() {
            this.classList.remove("is-open");
            this.hidden = true;
            this.product = null;
            document.removeEventListener("keydown", this.boundHandleKeydown);
          }
          renderOptions() {
            const names = getOptionNames(this.product);
            this.optionsEl.innerHTML = "";
            names.forEach((name, index) => {
              const group = document.createElement("div");
              group.className = "cart-upsell-picker__option";
              const label = document.createElement("div");
              label.className = "cart-upsell-picker__option-name";
              label.textContent = name;
              group.appendChild(label);
              if (this.sizeGuideTemplate && this.sizeGuideVariants.includes(name.toLowerCase())) {
                group.appendChild(this.sizeGuideTemplate.content.cloneNode(true));
              }
              const list = document.createElement("div");
              list.className = "cart-upsell-picker__values";
              getOptionValues(this.product, index).forEach((value) => {
                const btn = document.createElement("button");
                btn.type = "button";
                btn.className = "cart-upsell-picker__value";
                btn.textContent = value;
                btn.dataset.upsellValue = value;
                btn.dataset.optionIndex = index;
                btn.disabled = !isValueAvailable(this.product, index, value, this.selected);
                if (this.selected[index] === value) btn.classList.add("is-selected");
                list.appendChild(btn);
              });
              group.appendChild(list);
              this.optionsEl.appendChild(group);
            });
            this.updateSubmitState();
          }
          /**
           * Handles an option value being chosen.
           * @param {Element} btn - The value button.
           */
          selectValue(btn) {
            const index = parseInt(btn.dataset.optionIndex, 10);
            const { upsellValue } = btn.dataset;
            this.selected[index] = this.selected[index] === upsellValue ? null : upsellValue;
            this.selected = this.selected.map((value, i) => {
              if (!value || i === index) return value;
              return isValueAvailable(this.product, i, value, this.selected) ? value : null;
            });
            this.renderOptions();
            this.setError("");
          }
          updateSubmitState() {
            this.variant = findVariant(this.product, this.selected);
            this.submitBtn.disabled = !this.variant || !this.variant.available;
          }
          handleSubmit() {
            return __async(this, null, function* () {
              if (!this.variant) return;
              this.submitBtn.disabled = true;
              this.submitBtn.classList.add("is-loading");
              try {
                yield addToCart(this.variant.id);
                this.close();
              } catch (error) {
                this.setError(error.message);
                this.submitBtn.disabled = false;
              } finally {
                this.submitBtn.classList.remove("is-loading");
              }
            });
          }
          /**
           * @param {string} message - Error message ('' clears it).
           */
          setError(message) {
            this.errorEl.textContent = message;
            this.errorEl.hidden = !message;
          }
        };
        __name(_CartUpsellPicker, "CartUpsellPicker");
        let CartUpsellPicker = _CartUpsellPicker;
        customElements.define("cart-upsell-picker", CartUpsellPicker);
      }
      document.addEventListener("click", (evt) => __async(null, null, function* () {
        const btn = evt.target.closest("[data-upsell-atc]");
        if (!btn || btn.disabled) return;
        evt.preventDefault();
        const picker = document.querySelector("cart-upsell-picker");
        const { productHandle, variantId, needsOptions } = btn.dataset;
        btn.classList.add("is-loading");
        btn.disabled = true;
        try {
          if (!needsOptions && variantId) {
            yield addToCart(variantId);
            return;
          }
          if (!picker) return;
          const response = yield fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
          picker.open(yield response.json());
        } catch (error) {
          console.warn(error);
        } finally {
          btn.classList.remove("is-loading");
          btn.disabled = false;
        }
      }));
    }
  });
  require_cart_upsell();
})();
